import { Component, Input } from '@angular/core';
import { SelectedItem } from '@app/lists/shared/list-detail-management/model/selected-product.model';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformEnum, PlatformService } from '@panamax/app-state';
import { ListGroupState, ListItemState, ListState } from '@usf/ngrx-list';
import { BehaviorSubject } from 'rxjs';
import { ProductRow } from '../../shared/list-detail-management/model/list-detail-management-view.model';
import { ListKey } from '@usf/list-types';
import { CopyProductsModalComponent } from '../copy-products-modal/copy-products-modal.component';

@Component({
  selector: 'app-copy-products-modal-container',
  templateUrl: './copy-products-modal-container.component.html',
  styleUrls: ['./copy-products-modal-container.component.scss'],
})
export class CopyProductsModalContainerComponent {
  isModalOpen$ = new BehaviorSubject(false);
  title = '';
  selectedProducts: ProductRow[] = [];
  list: ListState;
  groups: ListGroupState[] = [];
  platform: PlatformEnum;
  selectedGroup: ListGroupState;
  listItems: ListItemState[];
  platformRef = PlatformEnum;
  enableCopyToList: boolean;
  hideCopyToListOption: boolean;
  modalRef = CopyProductsModalComponent;
  @Input() getListsforUser: Function;
  @Input() getListsLoaded: Function;
  @Input() finalSubmission: Function;
  @Input() enableCopyToListFuc: Function;
  @Input() hideCopyToListOptionFunc: Function;

  constructor(
    public platformService: PlatformService,
    public modalController: ModalController,
    readonly translateService: TranslateService,
  ) {}

  async openModal(
    selectedProducts: ProductRow[],
    list: ListState,
    groups: ListGroupState[],
    selectedGroup: ListGroupState,
    listItems: ListItemState[],
  ) {
    this.selectedProducts = selectedProducts;
    this.list = list;
    this.groups = groups;
    this.selectedGroup = selectedGroup;
    this.listItems = listItems;
    this.title =
      this.selectedProducts.length === 1
        ? this.translateService.instant(
            'i18n.lists.copyProductsModal.copyProductHeader',
            { amount: this.selectedProducts.length },
          )
        : this.translateService.instant(
            'i18n.lists.copyProductsModal.copyProductsHeader',
            { amount: this.selectedProducts.length },
          );
    this.platform = this.platformService.getPlatformType();
    this.enableCopyToList = await this.enableCopyToListFuc();
    this.hideCopyToListOption = await this.hideCopyToListOptionFunc();
    this.isModalOpen$.next(true);
  }

  dismissModal = () => {
    this.isModalOpen$.next(false);
  };

  async createCopyProductsModal(selectedProducts: SelectedItem[]) {}

  getListData = async () => {
    return await this.getListsforUser();
  };

  getLoaded = () => {
    return this.getListsLoaded();
  };

  onSubmit = () => {};

  next() {}
}
